import Vue from 'vue';
import VueRouter from 'vue-router';
import routes from './routes';

import store from '../store';
import checkAuth from '/plugins/auth';
//import qs from 'querystring';



Vue.use(VueRouter);

const router = new VueRouter({
    //mode: 'history',
    routes
});


router.beforeEach(async (to, from, next) => {
    try {
        

        if (store.state.loading) {
            do {
                await new Promise((resolve, reject) => {
                    window.setTimeout(() => {
                        resolve();
                    }, 500);
                })
            } while (store.state.loading);
        }
        const isPublic = !!to.meta.isPublic;
        const isPrivate = !!to.meta.isPrivate;
        const isAuthenticated = !!store.getters.isAuthenticated;

        if (isAuthenticated) {

            if (/^\/login/igm.test(to.path) && to.query?.redirect) {
                next(to.query.redirect);
                return
            }

            if (/^\/solicitacao-de-pagamento\/sou-fornecedor/igm.test(to.path)) {
                
                try {

                    await Promise.all([
                        store.dispatch('setCliente', {}),
                        store.dispatch('setRelacoes', []),
                        store.dispatch('setRelacaoId', 0),
                        store.dispatch('setCondominioId', 0),
                        store.dispatch('setContratoId', 0),
                        store.dispatch('setImovelId', 0),
                        store.dispatch('setRefreshToken', null),
                        store.dispatch('setJwt', null)
                    ]);

                    next('/solicitacao-de-pagamento')
                    return
                } catch (error) {
                    console.error(error);
                }
            }
            
            if (/^\/solicitacao-de-pagamento/igm.test(to.path)) {
                
                const relacao = store.getters.relacao
                const sistema = relacao?.sistema || null
                const controle_acesso = store.getters.controleAcesso
                const pode_acessar = sistema == 'C' && controle_acesso && controle_acesso.solicitacaoPagamento && controle_acesso.solicitacaoPagamento.acesso
                const pode_consultar = sistema == 'C' && controle_acesso && controle_acesso.solicitacaoPagamento && controle_acesso.solicitacaoPagamento.consulta
                if (!pode_acessar && !pode_consultar) {
                    next('/');
                    return
                }

                if (/^\/solicitacao-de-pagamento\/(historico)/igm.test(to.path) && !pode_consultar) {
                    next('/');
                    return
                }
                if (/^\/solicitacao-de-pagamento\/(busca-fornecedor|busca-condominio|cadastro-condominio|cadastro-fornecedor|solicitacao)/igm.test(to.path) && !pode_acessar) {
                    next('/');
                    return
                }

            }
        } else if (/^\/solicitacao-de-pagamento\/sou-fornecedor/igm.test(to.path)) {
            next('/solicitacao-de-pagamento');
            return
        }

        if (!isPublic && !isAuthenticated) {         
            
            next({
                path: "/login", query: {
                    redirect: to.fullPath
                }
            });
        } else if (isPublic && isAuthenticated && !isPrivate) {
            
            next('/');
        } else {
            next();
        }
    } catch (error) {
        console.error(error);
    }

});

router.afterEach((to, from) => {
    try {
        store.dispatch('hideDrawer');
        checkAuth();

    } catch (err) {
        console.error(err);
    }
});


export default router;
